import {Alert, Snackbar} from '@mui/material';
import React, {createContext, useCallback, useContext, useState} from 'react';

const SnackbarContext = createContext();

export const SnackbarProvider = ({children}) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');
    const [variant, setVariant] = useState('');

    const showSnackbar = useCallback((message, options = {}) => {
        setMessage(message);
        setSeverity(options.severity || 'info');
        setVariant(options.variant || '');
        setOpen(true);
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <SnackbarContext.Provider value={{showSnackbar}}>
            {children}
            <Snackbar
                open={open}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                autoHideDuration={6000}
                sx={{zIndex: 9999}}
                onClose={handleClose}
            >
                <Alert
                    {...(['filled', 'outlined'].includes(variant) ? {variant} : {})}
                    severity={severity}
                    sx={{width: '100%'}}
                    onClose={handleClose}
                >
                    {message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => {
    return useContext(SnackbarContext);
};
